<template>
    <div class="row">
        <div class="col-xs-12 col-lg-12">
            <div class="container-heading">
                <div class="row">
                    <div class="col-xs-12 col-lg-4 heading-page">
                        <small><b>Resumo</b> <span v-popover:tooltip.right="'Revise as informações coletadas para o roteiro'"><i class="fas fa-question-circle"></i></span></small>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-xs-12 col-lg-12">
            <div class="container-button-top">
                <div class="row">
                    <div class="col-xs-12 col-lg-12">
                        <button class="button-edit button-cancel" :disabled="loading" @click="cancel" data-v-step-routing-form-step-4="1">
                            <i class="fa fa-fw fa-times"></i> CANCELAR
                        </button>
                        <button class="button-edit" :disabled="loading" @click="previousStep" data-v-step-routing-form-step-4="2">
                            <i class="fa fa-fw fa-caret-left"></i> VOLTAR
                        </button>
                        <button class="btn button-edit button-cancel btn-right" @click="$refs.tour.editTour()">
                            <i class="fas fa-question-circle"></i> TOUR
                        </button>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-xs-12 col-lg-12 container-summary" data-v-step-routing-form-step-4="3">
            <div class="col-xs-12 col-lg-12">
                <div class="row">
                    <div class="col-xs-12 col-lg-2">
                        <div class="square-summary">
                            <div class="square-summary-head">
                                <h3><i class="fa fa-fw fa-2x fa-calendar-alt"></i></h3>
                            </div>
                            <div class="square-summary-body">
                                <h3>DATA</h3>
                                <h2>{{ date.split("-").reverse().join("/") }}</h2>
                            </div>
                        </div>
                    </div>
                    <div class="col-xs-12 col-lg-2">
                        <div class="square-summary">
                            <div class="square-summary-head">
                                <h3><i class="fa fa-fw fa-2x fa-truck"></i></h3>
                            </div>
                            <div class="square-summary-body">
                                <h3>VEÍCULOS</h3>
                                <h2>{{ vehicle_total }}</h2>
                            </div>
                        </div>
                    </div>
                    <div class="col-xs-12 col-lg-2">
                        <div class="square-summary">
                            <div class="square-summary-head">
                                <h3><i class="fa fa-fw fa-2x fa-truck-loading"></i></h3>
                            </div>
                            <div class="square-summary-body">
                                <h3>CAPACIDADE</h3>
                                <h2>{{ getWeightCapacity(weight_capacity) }}</h2>
                            </div>
                        </div>
                    </div>
                    <div class="col-xs-12 col-lg-2">
                        <div class="square-summary">
                            <div class="square-summary-head">
                                <h3><i class="fa fa-fw fa-2x fa-boxes"></i></h3>
                            </div>
                            <div class="square-summary-body">
                                <h3>ENTREGAS</h3>
                                <h2>{{ delivery_total }}</h2>
                            </div>
                        </div>
                    </div>
                    <div class="col-xs-12 col-lg-2">
                        <div class="square-summary">
                            <div class="square-summary-head">
                                <h3><i class="fa fa-fw fa-2x fa-weight-hanging"></i></h3>
                            </div>
                            <div class="square-summary-body">
                                <h3>PESO</h3>
                                <h2>{{ getWeight(weight) }}</h2>
                            </div>
                        </div>
                    </div>
                    <div class="col-xs-12 col-lg-2">
                        <div class="square-summary">
                            <div class="square-summary-head">
                                <h3><i class="fa fa-fw fa-2x fa-map-marker-alt"></i></h3>
                            </div>
                            <div class="square-summary-body">
                                <h3>LOCAIS</h3>
                                <h2>{{ point_total }}</h2>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-xs-12 col-lg-offset-4 col-lg-4">
            <button class="button-edit button-routing" :disabled="loading" @click="send" data-v-step-routing-form-step-4="4">
                <i class="fa fa-fw fa-plus"></i> CRIAR ROTAS <i v-if="loading" class="fa fa-fw fa-circle-notch fa-spin"></i>
            </button>
        </div>
        <div class="col-xs-12 col-lg-12">
            <div class="container-button-bottom">
                <div class="row">
                    <div class="col-xs-12 col-lg-12">
                        <button class="button-edit button-cancel" :disabled="loading" @click="cancel">
                            <i class="fa fa-fw fa-times"></i> CANCELAR
                        </button>
                        <button class="button-edit" :disabled="loading" @click="previousStep">
                            <i class="fa fa-fw fa-caret-left"></i> VOLTAR
                        </button>
                    </div>
                </div>
            </div>
        </div>

        <Tour
            tour="DeliveryRouting"
            :steps="tour_steps"
			ref="tour"
        />
    </div>
</template>

<script>
import Api from "@/lib/Api";

import Tour from "@/components/Tour";

export default {
    name: "RoutingFormStep4",

    props: {
        data: {
            type: Object,
            require: true,
        },
    },

    components: {
        Tour,
    },

    data: function() {
        return {
            loading: false,
            list_point: [],
            date: this.data[1].date,
            vehicle_total: this.data[2].length,
            delivery_total: this.data[3].length,
            point_total: 0,
            weight_capacity: 0.00,
            weight: 0.00,
            points_with_zero_weight: 0,
            
            tour_steps: [
                {
                    target: '[data-v-step-routing-form-step-4="0"]',
                    header: {
                        title: '<code>PASSO ATUAL</code>',
                    },
                    content: '<code>Verifique aqui o passo atual</code>',
                    params: {
                        placement: 'bottom',
                        highlight: true,
                    }
                },
                {
                    target: '[data-v-step-routing-form-step-4="1"]',
                    header: {
                        title: '<code>CANCELAR</code>',
                    },
                    content: '<code>Clique em <b>CANCELAR</b> para interromper o processo e voltar para lista de roteiros</code>',
                    params: {
                        placement: 'right',
                        highlight: true,
                    }
                },
                {
                    target: '[data-v-step-routing-form-step-4="2"]',
                    header: {
                        title: '<code>VOLTAR</code>',
                    },
                    content: '<code>Clique em <b>VOLTAR</b> para voltar para a etapa anterior</code>',
                    params: {
                        placement: 'right',
                        highlight: true,
                    }
                },
                {
                    target: '[data-v-step-routing-form-step-4="3"]',
                    header: {
                        title: '<code>RESUMO</code>',
                    },
                    content: '<code>Verifique as informações coletadas para a roteirização</code>',
                    params: {
                        placement: 'top',
                        highlight: true,
                    }
                },
                {
                    target: '[data-v-step-routing-form-step-4="4"]',
                    header: {
                        title: '<code>ROTEIRIZAR</code>',
                    },
                    content: '<code>Clique em <b>CRIAR ROTAS</b> para iniciar o processamento do roteirização</code>',
                    params: {
                        placement: 'top',
                        highlight: true,
                    }
                },
            ],
        }
    },

    mounted: function() {
        this.processData();
        this.$refs.tour.setTour();
    },

    methods: {
        // Processa as informações
        processData: function() {
            this.capacity = 0;
            this.data[2].map(v => {
                // Soma as capacidades de todos os vículos
                if (v.weight_capacity) this.weight_capacity += v.weight_capacity;
            });

            this.data[3].map(p => {
                // Verifica se é uma nova localidade
                if(!this.list_point.includes(p.coordinates)) {
                    this.list_point.push(p.coordinates);
                    this.point_total++;
                }
                
                // Soma os pesos de todos as entregas
                if (p.weight) this.weight += p.weight;
            });
        },

        /**
         * Envia um horário e retorna o tempo em segundos
         * @param {string} startTime horário de início
         * @param {string} endTime horário de término
         * @return {number} retorna o tempo em segundos
         **/
        getTimeInSeconds: function(startTime, endTime) {
            // Calcula o tempo de início da rota
            startTime = startTime.split(":");
            let startHoursInSecond = parseInt(startTime[0]) * 3600;
            let startMinutsInSecond = 0;
            if(parseInt(startTime[1]) > 0) {
                startMinutsInSecond = parseInt(startTime[1]) * 60;
            }
            let startTimeTotal = startHoursInSecond + startMinutsInSecond;
            
            // Calcula o tempo de máximo de término da rota
            endTime = endTime.split(":");
            let endHoursInSecond = parseInt(endTime[0]) * 3600;
            let endMinutsInSecond = 0;
            if(parseInt(endTime[1]) > 0) {
                endMinutsInSecond = parseInt(endTime[1]) * 60;
            }
            let endTimeTotal = endHoursInSecond + endMinutsInSecond;
            
            // Define o total da rota
            return endTimeTotal - startTimeTotal;
        },
        
        /**
         * Constroi o objeto geral do para ser enviado a api de roteirização
         * @param {object} parameters objeto com as informações gerais
         * @return {object} objeto com o as informações base gerado
         **/
        buildJourney: function(parameters) {
            let JourneyDTO = new Object();
            
            JourneyDTO.depot = 0;
            
            JourneyDTO.startLunchTime = parameters.start_lunch_time ? parameters.start_lunch_time : "00:00";
            JourneyDTO.endLunchTime = parameters.end_lunch_time ? parameters.end_lunch_time : "00:00";
            
            JourneyDTO.averageSpeed = parameters.average_speed ? parameters.average_speed : 40;
            JourneyDTO.averageDischargeTime = parameters.average_discharge_time ? parameters.average_discharge_time : 0;
            JourneyDTO.dischargeWeightPerMinut = parameters.discharge_weight_per_minut ? parameters.discharge_weight_per_minut : 0;
            JourneyDTO.correctionFact = parameters.correction_fact ? parameters.correction_fact : 100;
            
            JourneyDTO.weightConstraints = parameters.weight_constraints ? parameters.weight_constraints : false;
            JourneyDTO.timeConstraints = parameters.time_constraints ? parameters.time_constraints : false;
            
            JourneyDTO.points = [];
            JourneyDTO.vehicles = [];

            return JourneyDTO;
        },

        /**
         * Constroi o objeto geral do para ser armazenado localmente
         * @param {object} parameters objeto com as informações gerais
         * @return {object} objeto com o as informações base gerado
         **/
        buildJourneyBase: function(parameters) {
            let JourneyDTO = new Object();

            var arr_data =  parameters.date.split('-');
            
            JourneyDTO.name = parameters.name;
            JourneyDTO.date  = new Date(arr_data[0], arr_data[1] - 1, arr_data[2]);
            JourneyDTO.depot = 0;

            JourneyDTO.startTime = parameters.start_time ? parameters.start_time : "00:00";
            JourneyDTO.endTime = parameters.end_time ? parameters.end_time : "00:00";
            JourneyDTO.startLunchTime = parameters.start_lunch_time ? parameters.start_lunch_time : "00:00";
            JourneyDTO.endLunchTime = parameters.end_lunch_time ? parameters.end_lunch_time : "00:00";
            JourneyDTO.lunchTime = this.getTimeInSeconds(JourneyDTO.startLunchTime, JourneyDTO.endLunchTime);

            JourneyDTO.averageSpeed = parameters.average_speed ? parameters.average_speed : 40;
            JourneyDTO.averageDischargeTime = parameters.average_discharge_time ? parameters.average_discharge_time : 0;
            JourneyDTO.dischargeWeightPerMinut = parameters.discharge_weight_per_minut ? parameters.discharge_weight_per_minut : 0;
            JourneyDTO.correctionFact = parameters.correction_fact ? parameters.correction_fact : 100;
            
            JourneyDTO.weightConstraints = parameters.weight_constraints ? parameters.weight_constraints : false;
            JourneyDTO.timeConstraints = parameters.time_constraints ? parameters.time_constraints : false;

            JourneyDTO.points = [];
            JourneyDTO.vehicles = [];

            return JourneyDTO;
        },
        
        /**
         * Constroi os veículos a serem enviados para a api de roterização
         * @param {object} vehicle objeto com as informações do veículo
         * @param {number} index índice do veículo
         * @return objeto de envio do veículo
         **/
        buildVehicle(vehicle, index) {    
            let JourneyVehicleDTO = new Object();

            JourneyVehicleDTO.id = index;
            JourneyVehicleDTO.weightCapacity = Math.ceil(vehicle.weight_capacity);
            JourneyVehicleDTO.returnOrigin = vehicle.return_origin;

            return JourneyVehicleDTO;
        },

        /**
         * Constroi os veículos a serem armazenados localmente
         * @param {object} vehicle objeto com as informações do veículo
         * @param {object} parameters objeto com as informações gerais
         * @param {number} index índice do veículo
         * @return objeto de envio do veículo
         **/
        buildVehicleBase(vehicle, parameters, index) {
            let JourneyVehicleDTO = new Object();
            
            JourneyVehicleDTO.id = index;
            
            JourneyVehicleDTO.vehicleLicensePlate = vehicle.license_plate;
            JourneyVehicleDTO.vehicleBrand = vehicle.brand ? vehicle.brand : "";
            JourneyVehicleDTO.vehicleType = vehicle.vehicle_type ? vehicle.vehicle_type : "";
            JourneyVehicleDTO.vehicleBodywork = vehicle.bodywork ? vehicle.bodywork : "";
            JourneyVehicleDTO.vehicleWeightCapacity = vehicle.weight_capacity;
            JourneyVehicleDTO.returnOrigin = vehicle.return_origin;
            
            JourneyVehicleDTO.startLunchTime = parameters.start_lunch_time ? parameters.start_lunch_time : "00:00";
            JourneyVehicleDTO.endLunchTime = parameters.end_lunch_time ? parameters.end_lunch_time : "00:00";
            JourneyVehicleDTO.lunchTime = this.getTimeInSeconds(JourneyVehicleDTO.startLunchTime, JourneyVehicleDTO.endLunchTime);
            JourneyVehicleDTO.averageSpeed = parameters.average_speed ? parameters.average_speed : 40;
            
            JourneyVehicleDTO.driverDocument = vehicle.document ? vehicle.document : "";
            
            JourneyVehicleDTO.companyBranchCode = parameters.company_branch_code ? parameters.company_branch_code : "";

            return JourneyVehicleDTO;
        },

        /**
         * Constroi os pontos a serem enviados para a API de roterização. 
         * @param {object} point objeto de informações do ponto
         * @param {object} parameters objeto com informações gerais
         * @param {number} index índice do ponto
         **/
        buildPoint(point, parameters, index) {
            let JourneyPointDTO = new Object();
            
            JourneyPointDTO.id = index;
            JourneyPointDTO.documentIdentifier = point.document_identifier ? point.document_identifier : "";
            JourneyPointDTO.coordinates = point.coordinates ? point.coordinates : point.coordinates;
            JourneyPointDTO.demands = point.weight ? [Math.ceil(point.weight)] : [0];
            JourneyPointDTO.startTime = point.start_time ? point.start_time : "";
            JourneyPointDTO.endTime = point.end_time ? point.end_time : "";
            JourneyPointDTO.averageDischargeTime = point.average_discharge_time ? point.average_discharge_time : 0;
            JourneyPointDTO.dischargeWeightPerMinut = parameters.discharge_weight_per_minut ? parameters.discharge_weight_per_minut : 0;
            
            // Verifica o peso se não for Centro de Distribuição
            if((point.weight == 0) && (point.is_dc == 0)) {
                this.points_with_zero_weight++;
            }
            
            return JourneyPointDTO;
        },

        /**
         * Constroi os pontos a serem armazenados localmente
         * @param {object} point objeto de informações do ponto
         * @param {object} parameters objeto com informações gerais
         * @param {object} index índice do ponto
         **/
        buildPointBase(point, parameters, index) {
            let JourneyPointDTO = new Object();
            
            JourneyPointDTO.id = index;
            
            JourneyPointDTO.isDC = point.is_dc ? point.is_dc : 0;
            JourneyPointDTO.dcName = point.is_dc ? point.name : "";

            JourneyPointDTO.deliveryCompanyBranchCode = point.code_company_branch ? point.code_company_branch : "";

            JourneyPointDTO.documentCode = point.document_code ? point.document_code : "";
            JourneyPointDTO.movimentTypeCode = point.code_moviment_type ? point.code_moviment_type : null;
            JourneyPointDTO.documentIdentifier = point.document_identifier ? point.document_identifier : "";
            JourneyPointDTO.documentNumber = point.document_number ? point.document_number : "";
            JourneyPointDTO.weight = point.weight ? point.weight : 0.00;
            
            JourneyPointDTO.customerID = point.fk_customer ? point.fk_customer : 0;
            JourneyPointDTO.customerName = point.is_dc ? "" : point.customer_name;
            JourneyPointDTO.customerDocument = point.customer_document ? point.customer_document : "";
            JourneyPointDTO.customerCode = point.customer_code ? point.customer_code : "";

            JourneyPointDTO.observationID = point.fk_delivery_observation ? point.fk_delivery_observation : 0;
            JourneyPointDTO.observation = point.observation ? point.observation: "";
            
            JourneyPointDTO.addressID = point.fk_address ? point.fk_address : "";
            JourneyPointDTO.addressPostalCode = point.postal_code ? point.postal_code : "";
            JourneyPointDTO.addressStreet = point.street ? point.street : "";
            JourneyPointDTO.addressNumber = point.number ? point.number : "";
            JourneyPointDTO.addressComplement = point.complement ? point.complement  : "";
            JourneyPointDTO.addressNeighborhood = point.neighborhood ? point.neighborhood : "";
            JourneyPointDTO.addressUf = point.uf ? point.uf : "";
            JourneyPointDTO.addressCity = point.city ? point.city : "";
            JourneyPointDTO.coordinates = point.coordinates ? point.coordinates : point.coordinates;
            
            JourneyPointDTO.startTime = point.start_time ? point.start_time : "00:00";
            JourneyPointDTO.endTime = point.end_time ? point.end_time : "00:00";
            
            JourneyPointDTO.averageDischargeTime = point.average_discharge_time ? point.average_discharge_time : 0;
            JourneyPointDTO.dischargeWeightPerMinut = parameters.discharge_weight_per_minut ? parameters.discharge_weight_per_minut : 0;
            
            return JourneyPointDTO;
        },
        
        /**
         * Valida as informação que serão roteirizadas
         **/
        validation: function() {
            let JourneyDTOBase = new Object();
            let JourneyDTO = new Object();
            let error = false;
        
            let parameters = this.data[1];
            
            // Verifica os parâmetros da etapa 1
            if(parameters) {
                // Define as inbformações gerais
                JourneyDTO = this.buildJourney(parameters);
                JourneyDTOBase = this.buildJourneyBase(parameters);
            } else {
                error = true;
            }
            
            // Define as informações dos veículos
            let vehicles = this.data[2];
            if(vehicles) {
                vehicles.map((vehicle, index) => {
                    JourneyDTO.vehicles.push(this.buildVehicle(vehicle, index));
                    JourneyDTOBase.vehicles.push(this.buildVehicleBase(vehicle, parameters, index));
                });
            } else {
                error = true;
            }
            
            // Define as informações do centro de distribuição
            let distribution = parameters.distribution_center;
            if(distribution) {
                distribution.start_time = "00:00";
                distribution.end_time = "00:00";

                JourneyDTO.points.push(this.buildPoint(distribution, parameters, 0));
                JourneyDTOBase.points.push(this.buildPointBase(distribution, parameters, 0));
            } else {
                error = true;
            }
            
            // Define as informações do ponto
            let points = this.data[3];
            if(points) {
                points.map((point, index) => {
                    JourneyDTO.points.push(this.buildPoint(point, parameters, index + 1));
                    JourneyDTOBase.points.push(this.buildPointBase(point, parameters, index + 1));
                });
            } else {
                error = true;
            }
            
            // Verifica se foi encontrado algum erro
            if(error) {
                return null;
            } else {
                return {
                    data: JourneyDTO,
                    base: JourneyDTOBase,
                };
            }
        },
        
        /**
         * Envia para API e gera a rota
         **/
        send: async function() {
            // Obtém o limite de roteirizações diário
            // await this.getRoutingLimit();
            
            // Obtém o total de roteirizações de hoje
            // await this.getTodaysConsumption();

            // Obtém a autorização para roteirizar
            // let routingLimitAuth = await this.verifyRoutingLimit();

            // Verifica se é permitido roteirizar
            // if (routingLimitAuth) {
                // Solicita a validação
                let form = this.validation();

                // Verifica o resultado da validação
                if(form == null) {
                    return;
                }

                // Confirma se é para roteirzar sem a restrição de peso
                if(this.points_with_zero_weight > 0) {
                    // Apresenta a confirmação
                    let confirm = await this.$alert.confirm("Existem entregas sem o peso informado - SOMENTE SERÁ CONSIDERADA RESTRIÇÃO DE PESO SE TODAS AS ENTREGAS TIVEREM O PESO INFORMADO - Deseja continuar?", "AVISO");
                    if(!confirm) {
                        return;
                    }
                    this.$parent.data[1].weight_constraint = false;
                    
                    form.data.weightConstraints = false;
                    form.base.weightConstraints = false;
                } else {
                    this.$parent.data[1].weight_constraint = true;
                    
                    form.data.weightConstraints = true;
                    form.base.weightConstraints = true;
                }

                // Emite o carregamento
                this.$emit("loading", true);
                this.loading = true;
                
                // Requisita o salvamento
                let result = null;
                
                // Requisita a API
                try {
                    result = await Api.routing(form.data);
                } catch(ex) {
                    console.log(ex);
                    
                    setTimeout(async () => {
                        // Requisita novamente a API            
                        try {
                            result = await Api.routing(form.data);
                        } catch(ex) {
                            this.$emit("loading", false);
                            this.loading = false;
                            
                            this.$notification.error("Não foi possível processar o roteiro. Por favor, tente novamente.");
                            return;
                        }
                    }, 10 * 1000);
                }
                
                // Verifica se houve resultado
                if(result) {
                    // Atualiza a quantidade de roteirizações consumidas
                    // await this.updateTodaysConsumption();

                    //Verifica o resultado da requisição
                    if(result.error) {
                        // Emite o carregamento
                        this.$emit("loading", false);
                        this.loading = false;
                        
                        this.$notification.error(result.data);
                        return;
                    }
                    
                    // Emite o carregamento
                    this.$emit("loading", false);
                    this.loading = false;
                    //Emite o resultado
                    this.$emit('update', {
                        result: result.result,
                        base: form.base,
                    });
                    this.$emit('send', 'map');
                } else {
                    // Emite o carregamento
                    this.$emit("loading", false);
                    this.loading = false;

                    this.$notification.error("Não foi possível gerar um roteiro. Por favor, tente novamente.");
                    return;
                }
            // }
		},
        
        // Retorna a etapa anterior
        previousStep: function() {
            this.$emit("previous");
        },
        
        // Retorna a lista cancelando a operação
        cancel: function () {
            this.$emit("cancel");
        },

        getWeight: function(weight) {
            let weight_formatted = "";

            if (weight < 1000) weight_formatted = weight.toFixed(2) + " kg";
            else weight_formatted = (weight / 1000).toFixed(2) + " t";

            return weight_formatted.replace(".", ",");
        },

        getWeightCapacity: function(weight) {
            let weight_formatted = "";

            if (weight < 1000) weight_formatted = weight.toFixed(2) + " kg";
            else weight_formatted = (weight / 1000).toFixed(2) + " t";

            return weight_formatted.replace(".", ",");
        },

        /**
         * Verifica se é permitido roteirizar
         */
        verifyRoutingLimit: async function() {
            if ((this.$api.user.company_routing_limit == null) && (this.$api.user.company_routing_consumption == null)) {
                await this.$alert.alert("Não foi possível identificar o seu limite de roteirizações e seu consumo de hoje, favor entrar em contato com o suporte.", "AVISO");
                return false;
            } else if ((this.$api.user.company_routing_limit == 0) || (this.$api.user.company_routing_limit == null)) {
                await this.$alert.alert("Verificamos que você não possui roteirizações disponíveis. Caso queira utilizar a roteirização, favor entrar em contato com o suporte.", "AVISO");
                return false;
            } else if (this.$api.user.company_routing_limit == this.$api.user.company_routing_consumption) {
                await this.$alert.alert("Verificamos que você excedeu o seu limite de usos da função de roteirização. Seu serviço será bloqueado até a reposição dos usos diários. Caso queira continuar utilizando a roteirização, favor entrar em contato com o suporte.", "AVISO");
                return false;
            } else if (this.$api.user.company_routing_limit > this.$api.user.company_routing_consumption)
                return true;
        },

        // getNewRoutingExtraLimit: async function() {
        //     let input = {
        //         type: "tel",
        //         placeholder: "Digite", 
        //         value: "",
        //         required: true,
        //         mask: ['#', '##', '###'],
        //         tooltip: "Insira a quantidade de roteirizações que deseja acrescentar"
        //     }
        //     let result = await this.$alert.prompt("Quantas roteirizações gostaria de adquirir?", "ADCIONAR ROTEIRIZAÇÕES EXTRAS", input);
        //     if (typeof result === "string")
        //         result = parseInt(result);
        //     else
        //         result = false;
        //     return result;
        // },

        /**
         * Obtém o limite de roteirizações
         */
         getRoutingLimit: async function() {
            let result = null;

			try {
				result = await Api.get("company/get-routing-limit");
			} catch (ex) {
				console.log(ex);
                this.$api.user.company_routing_limit = null;
                this.$notification.error("Não foi possível obter as informações.");
                return;
			}

			if (result) {
				if (result.error) {
					if (result.data == "unauthorized") {
						this.$notification.error("Desculpe, sua sessão expirou.");
						setTimeout(() => { 
							Api.logout();
							return;
						}, 2000);
					} else {
						this.$notification.error(result.data);
						return;
					}
				} else
					this.$api.user.company_routing_limit = result.data;
			} else {
                this.$api.user.company_routing_limit = null;
				this.$notification.error("Não foi possível obter o limite de roteirizações diário.");
				return;
			}
        },
        
        /**
         * Obtém o total de roteirizações de hoje
         */
         getTodaysConsumption: async function() {
            let result = null;

			try {
				result = await Api.get("company-daily-routing/get-todays-consumption");
			} catch (ex) {
				console.log(ex);
                this.$api.user.company_routing_consumption = null;
                this.$notification.error("Não foi possível obter as informações.");
                return;
			}

			if (result) {
				if (result.error) {
					if (result.data == "unauthorized") {
						this.$notification.error("Desculpe, sua sessão expirou.");
						setTimeout(() => { 
							Api.logout();
							return;
						}, 2000);
					} else {
						this.$notification.error(result.data);
						return;
					}
				} else
					this.$api.user.company_routing_consumption = result.data;
			} else {
                this.$api.user.company_routing_consumption = null;
				this.$notification.error("Não foi possível obter o total de roteirizações consumidas.");
				return;
			}
        },
        
        /**
         * Atualiza a quantidade de roteirizações consumidas
         */
        updateTodaysConsumption: async function() {
            let result = null;

			try {
				result = await Api.post("company-daily-routing/update-todays-consumption");
			} catch (ex) {
				console.log(ex);
                this.$api.user.company_routing_consumption = null;
                this.$notification.error("Não foi possível atualizar as informações.");
                return;
			}

			if (result) {
				if (result.error) {
					if (result.data == "unauthorized") {
						this.$notification.error("Desculpe, sua sessão expirou.");
						setTimeout(() => { 
							Api.logout();
							return;
						}, 2000);
					} else {
						this.$notification.error(result.data);
						return;
					}
				} else {
					this.$api.user.company_routing_consumption = result.data;
				}
			} else {
                this.$api.user.company_routing_consumption = null;
				this.$notification.error("Não foi possível atualizar o total de roteirizações consumidas.");
				return;
			}
        },
    }
}
</script>

<style scoped>
.container-heading {
    padding: 15px;
    border-top: 1px solid #f0f0f0;
    background-color: #fff;
}

.heading-page {
    padding: 7.5px 10px;
}

.container-button-add {
    padding: 15px;
    border: 1px solid #f0f0f0;
    background-color: #fff;
}

.container-summary {
    padding: 15px;
    border-top: 1px solid #f0f0f0;
    border-bottom: 1px solid #f0f0f0;
}

.square-summary {
    margin: 15px 0px;
    border: 1px solid #595959;
    border-radius: 5px;
    color: #595959;
    text-align: center;
}

.square-summary-head {
    border-top-left-radius: 5px;
    border-top-right-radius: 5px;
    padding: 10px;
    color: #595959;
    text-align: center;
    background-color: #fff;
}

.square-summary-body {
    border-bottom-left-radius: 5px;
    border-bottom-right-radius: 5px;
    padding: 10px;
    text-align: center;
    background-color: #eee;
}

/*.square-summary:hover {
    background-color: #eeeeee;
}*/

.container-button-top {
    padding: 15px;
    border-top: 1px solid #f0f0f0;
    background-color: #fff;
}

.container-button-bottom {
    padding: 15px;
    border-top: 1px solid #f0f0f0;
    border-bottom-right-radius: 4px;
    border-bottom-left-radius: 4px;
    background-color: #fff;
}

.button-edit {
    padding: 10px 20px;
	font-size: 14px;
	font-weight: bold;
}

.button-cancel {
    color: #595959;
    background-color: #d9d9d9;
}

.button-routing {
    width: 100%;
    font-size: 16px;
    margin-top: 60px;
    margin-bottom: 30px;
}

.loader-wrapper {
  position: absolute;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;  
  background: rgb(0, 0, 0, 0.8);
  z-index: 9999;  
  overflow: hidden;
}

.loader {
  position: absolute;
  left: 50%;
  top: 15%;  
  font-size: 40px;
  color: white;  
  text-align: center;
}

.loader-text {
    position: absolute;    
    left: 5%;
    top: 45%;
    width: 100%;
    height: 100%;    
    margin-top: 2%;
    font-size: 30px;
    color: white;    
    text-align: center;
}
</style>